<template>
    <div style="text-align:left;">
        <a-button style="margin-top:20px;" type="primary" @click="ShowModalAdd">
            {{ i18n.$t('AccountManageModalAddButton') }}
        </a-button>
        <a-modal
            :title="i18n.$t('AccountManageModalAddTitle')"
            :width = "600"
            :visible="ModalVisibleAdd"
            :confirm-loading="ConfirmLoadingAdd"
            ok-text="Push"
            @ok="handleOkAdd"
            @cancel="handleCancelAdd"
        >  
            <van-field v-model="AccountAddForm.username" :label="i18n.$t('AccountAddFormUserName')" :placeholder="i18n.$t('AccountAddFormUserNamePH')"/>
            <van-field v-model="AccountAddForm.department" :label="i18n.$t('AccountAddFormDepartment')" :placeholder="i18n.$t('AccountAddFormDepartmentPH')" />
            <van-field v-model="AccountAddForm.password" :label="i18n.$t('AccountAddFormPassword')" :placeholder="i18n.$t('AccountAddFormPasswordPH')" />
            <van-field v-model="AccountAddForm.country" :label="i18n.$t('AccountAddFormCountry')" :placeholder="i18n.$t('AccountAddFormCountryPH')" />
            <van-field v-model="AccountAddForm.email" :label="i18n.$t('AccountAddFormEmail')" :placeholder="i18n.$t('AccountAddFormEmailPH')" />
            <van-field name="radio" :label="i18n.$t('AccountAddFormRole')">
                <template #input>
                    <van-radio-group v-model="AccountAddForm.role" direction="horizontal">
                        <van-radio style="padding:10px 0px;" v-for="role in rolelist" :key="role.id" :name="role.name">{{ role.name }}</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- <van-field name="radio" :label="i18n.$t('AccountAddFormIsActive')">
                <template #input>
                    <van-radio-group v-model="AccountAddForm.active" direction="horizontal">
                        <van-radio name = true>是</van-radio>
                        <van-radio name = false>否</van-radio>
                    </van-radio-group>
                </template>
            </van-field> -->
            <van-field v-model="AccountAddForm.tips" :label="i18n.$t('AccountAddFormTips')" :placeholder="i18n.$t('AccountAddFormTipsPH')" />
        </a-modal>
        <a-modal
            :title="i18n.$t('AccountManageModalEditTitle')"
            :width = "600"
            :visible="ModalVisibleEdit"
            :confirm-loading="ConfirmLoadingEdit"
            ok-text="Push"
            @ok="handleOkEdit"
            @cancel="handleCancelEdit"
        >  
            <van-field v-model="AccountEditForm.username" :label="i18n.$t('AccountAddFormUserName')" :placeholder="i18n.$t('AccountAddFormUserNamePH')"/>
            <van-field v-model="AccountEditForm.department" :label="i18n.$t('AccountAddFormDepartment')" :placeholder="i18n.$t('AccountAddFormDepartmentPH')" />
            <van-field v-model="AccountEditForm.password" :label="i18n.$t('AccountAddFormPassword')" :placeholder="i18n.$t('AccountAddFormPasswordPH')" />
            <van-field v-model="AccountEditForm.country" :label="i18n.$t('AccountAddFormCountry')" :placeholder="i18n.$t('AccountAddFormCountryPH')" />
            <van-field v-model="AccountEditForm.email" :label="i18n.$t('AccountAddFormEmail')" :placeholder="i18n.$t('AccountAddFormEmailPH')" />
            <van-field name="radio" :label="i18n.$t('AccountAddFormRole')">
                <template #input>
                    <van-radio-group v-model="AccountEditForm.role" direction="horizontal">
                        <van-radio style="padding:10px 0px;" v-for="role in rolelist" :key="role.id" :name="role.name">{{ role.name }}</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- <van-field name="radio" :label="i18n.$t('AccountAddFormIsActive')">
                <template #input>
                    <van-radio-group v-model="AccountEditForm.active" direction="horizontal">
                        <van-radio name = true>是</van-radio>
                        <van-radio name = false>否</van-radio>
                    </van-radio-group>
                </template>
            </van-field> -->
            <van-field v-model="AccountEditForm.tips" :label="i18n.$t('AccountAddFormTips')" :placeholder="i18n.$t('AccountAddFormTipsPH')" />
        </a-modal>
        <a-table 
            bordered
            :data-source="AccountData"
            :columns="columns"
            :row-key="record => record.id"
            :scroll="{ x: 1040 }">
            <template #operation="{ record }">
                <a-button type="primary" @click="ShowModalEdit(record)">{{ i18n.$t('AccountManageTabelEdit') }}</a-button>
                <a-popconfirm
                    v-if="AccountData.length"
                    title="Sure to delete?"
                    @confirm="onDelete(record.id)"
                >
                    <a-button style="margin-top:5px;" type="danger">{{ i18n.$t('AccountManageTabelDelete') }}</a-button>
                </a-popconfirm>
            </template>
            <template #active="{ record }">
                <label v-if="record.active" >{{ i18n.$t('AccountAddFormIsActivet') }}</label>
                <label v-else >{{ i18n.$t('AccountAddFormIsActivef') }}</label>
            </template>
        </a-table>
    </div>
</template>

<script>
    import { useI18n } from "@/i18nPlugin";
    import { defineComponent, ref } from "vue";
    import { message } from 'ant-design-vue';
    import { 
        SearchAccountManageData,
        AddAccountManageData,
        EditAccountManageData,
        DeleteAccountManageData,
        SearchRoleData
    } from '../api/index';
    export default defineComponent({
        setup() {
            const i18n = useI18n();
            const token = localStorage.getItem("userToken");
            const columns =  ref([
                {
                    title: i18n.$t('AccountAddFormUserName'),
                    width: 150,
                    dataIndex: 'username',
                    fixed: 'left'
                },
                {
                    title: i18n.$t('AccountAddFormDepartment'),
                    width: 150,
                    dataIndex: 'department',
                },
                {
                    title: i18n.$t('AccountAddFormRole'),
                    width: 150,
                    dataIndex: 'role',
                },
                {
                    title: i18n.$t('AccountAddFormCountry'),
                    width: 150,
                    dataIndex: 'country',
                },
                {
                    title: i18n.$t('AccountAddFormEmail'),
                    width: 250,
                    dataIndex: 'email',
                },
                {
                    title: i18n.$t('AccountAddFormIsActive'),
                    width: 150,
                    dataIndex: 'active',
                    slots: { customRender: 'active' },
                },
                {
                    title: i18n.$t('AccountAddFormTips'),
                    width: 150,
                    dataIndex: 'tips',
                },
                {
                    title: i18n.$t('AccountAddFormPassword'),
                    width: 150,
                    dataIndex: 'password',
                    ellipsis: true,
                },
                {
                    title: i18n.$t('AccountManageTabelCreatetime'),
                    width: 150,
                    dataIndex: 'dateJoined',
                },
                {
                    title: i18n.$t('AccountManageTabelCreater'),
                    width: 150,
                    dataIndex: 'creator',
                },
                {
                    title: i18n.$t('AccountManageTabelEditTime'),
                    width: 150,
                    dataIndex: 'dateModify',
                },
                {
                    title: i18n.$t('AccountManageTabelEditor'),
                    width: 150,
                    dataIndex: 'mender',
                },
                {
                    title: i18n.$t('AccountManageTabelOperation'),
                    dataIndex: 'operation',
                    fixed: 'right',
                    width: 100,
                    slots: { customRender: 'operation' },
                },
            ]);
            let AccountData =  ref([]);
            let rolelist =  ref([]);
            const pagination =  ref({});
            const loading =  ref(false);
            const SearchAccountManage = () => {
                SearchAccountManageData (token).then(res => {   
                    AccountData.value = res.data;
                }).catch(error => console.log(error));
            };
            const SearchRole = () => {
                SearchRoleData (token).then(res => {   
                    rolelist.value = res.data;
                }).catch(error => console.log(error));
            };
            const ModalVisibleAdd = ref(false);
            const ConfirmLoadingAdd = ref(false);
            const AddlabelCol = ref({ span: 5 })
            const AddwrapperCol = ref({ span: 14 })
            const ShowModalAdd = () => {
                ModalVisibleAdd.value = true;
            }
            const handleOkAdd = () => {
                ConfirmLoadingAdd.value = true;
                if(AccountAddForm.value.username == ""){
                    message.error('please enter username');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.password == ""){
                    message.error('please enter password');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.email == ""){
                    message.error('please enter email');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.country == ""){
                    message.error('please enter country');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.department == ""){
                    message.error('please enter department');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.role == ""){
                    message.error('please choose role');
                    ConfirmLoadingAdd.value = false;
                    return false
                }else if(AccountAddForm.value.tips == ""){
                    message.error('please enter tips');
                    ConfirmLoadingAdd.value = false;
                    return false
                }
                AddAccountManageData (AccountAddForm._rawValue,token).then(res => {
                    if(res.status == 200){
                        // this.$message.success('添加成功');
                        ConfirmLoadingAdd.value = false;
                        ModalVisibleAdd.value = false;
                        SearchAccountManage();
                        AccountAddForm.value.username = "";
                        AccountAddForm.value.password = "";
                        AccountAddForm.value.email = "";
                        AccountAddForm.value.country = "";
                        AccountAddForm.value.department = "";
                        AccountAddForm.value.active = true;
                        AccountAddForm.value.role = "";
                        AccountAddForm.value.tips = "";
                        // console.log(res)
                    }else {
                        message.error(res.msg);
                        ConfirmLoadingAdd.value = false;
                    }
                }).catch(error => {
                    ConfirmLoadingAdd.value = false;
                    console.log(error);
                })
            }
            const handleCancelAdd = () => {
                ModalVisibleAdd.value = false;
            }
            const AccountAddForm = ref({
                username: "",
                password: "",
                email: "",
                country: "",
                department: "",
                staff: false,
                superuser: false,
                active: true,
                role: "",
                tips: ""
            });
            const ModalVisibleEdit = ref(false);
            const ConfirmLoadingEdit = ref(false);
            const EditlabelCol = ref({ span: 5 })
            const EditwrapperCol = ref({ span: 14 })
            const ShowModalEdit = (record) => {
                // console.log(record)
                AccountEditForm.value.id = record.id
                AccountEditForm.value.username = record.username
                AccountEditForm.value.password = record.password
                AccountEditForm.value.email = record.email
                AccountEditForm.value.country = record.country
                AccountEditForm.value.department = record.department
                AccountEditForm.value.active = record.active
                AccountEditForm.value.role = record.role
                AccountEditForm.value.tips = record.tips
                ModalVisibleEdit.value = true;
            }
            const handleOkEdit = () => {
                ConfirmLoadingEdit.value = true;
                if(AccountEditForm.value.username == ""){
                    message.error('please enter username');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.password == ""){
                    message.error('please enter password');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.email == ""){
                    message.error('please enter email');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.country == ""){
                    message.error('please enter country');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.department == ""){
                    message.error('please enter department');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.role == ""){
                    message.error('please choose role');
                    ConfirmLoadingEdit.value = false;
                    return false
                }else if(AccountEditForm.value.tips == ""){
                    message.error('please enter tips');
                    ConfirmLoadingEdit.value = false;
                    return false
                }
                EditAccountManageData (AccountEditForm._rawValue,token).then(res => {
                    if(res.status == 200){
                        // this.$message.success('添加成功');
                        ConfirmLoadingEdit.value = false;
                        ModalVisibleEdit.value = false;
                        SearchAccountManage();
                        // console.log(res)
                    }else {
                        ConfirmLoadingEdit.value = false;
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    ConfirmLoadingEdit.value = false;
                    console.log(error);
                })
            }
            const handleCancelEdit = () => {
                ModalVisibleEdit.value = false;
            }
            const AccountEditForm = ref({
                id: "",
                username: "",
                password: "",
                email: "",
                country: "",
                department: "",
                staff: false,
                superuser: false,
                active: true,
                role: "",
                tips: ""
            });
            const onDelete = (id) => {
                // alert(id)
                // console.log(AccountData.value)
                DeleteAccountManageData ({
                    id: id
                },token).then(res => {
                    if(res.status == 200){
                        const TempAccountData = [...AccountData.value];
                        AccountData.value = TempAccountData.filter(item => item.id !== id);
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    console.log(error);
                })
            }

            return {
                i18n,
                token,
                SearchRole,
                rolelist,
                SearchAccountManage,
                AccountAddForm,
                ModalVisibleAdd,
                AddlabelCol,
                AddwrapperCol,
                ConfirmLoadingAdd,
                ShowModalAdd,
                handleOkAdd,
                handleCancelAdd,
                AccountEditForm,
                ModalVisibleEdit,
                EditlabelCol,
                EditwrapperCol,
                ConfirmLoadingEdit,
                ShowModalEdit,
                handleOkEdit,
                handleCancelEdit,
                pagination,
                loading,
                columns,
                AccountData,
                onDelete
            }
        },
        mounted() {
            this.SearchAccountManage();
            this.SearchRole();
        }
    })
</script>

<style scoped>

</style>